
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M18.333 9a3.333 3.333 0 012.777-3.289.666.666 0 00.557-.657V3c0-.737-.598-1.333-1.334-1.333H3c-.737 0-1.333.596-1.333 1.333v2.056c0 .325.235.604.556.657a3.334 3.334 0 010 6.578.667.667 0 00-.556.657V15c0 .736.596 1.333 1.333 1.333h17.333c.736 0 1.334-.597 1.334-1.333v-2.056a.665.665 0 00-.557-.657A3.334 3.334 0 0118.333 9zm-6.666-2.667h4.666"}}),_c('path',{attrs:{"d":"M14.667 9.667A1.667 1.667 0 1114.665 13a1.667 1.667 0 01.002-3.334zm-7-4.334a.333.333 0 11.667 0 .333.333 0 01-.667 0m0 4a.333.333 0 11.667 0 .333.333 0 01-.667 0m0 4a.333.333 0 11.667 0 .333.333 0 01-.667 0"}})])])
          )
        }
      }
    